import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchMe = useCallback(async () => {
    const token = localStorage.getItem("skillgap_token");
    if (!token) {
      setUser(null);
      setLoading(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user);
    } catch {
      localStorage.removeItem("skillgap_token");
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchMe(); }, [fetchMe]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("skillgap_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const signup = async (name, email, password, referral_code, mobile, attribution) => {
    const payload = { name, email, password };
    if (mobile) payload.mobile = mobile;
    if (referral_code) payload.referral_code = referral_code;
    if (attribution) {
      if (attribution.utm_source)   payload.utm_source   = attribution.utm_source;
      if (attribution.utm_medium)   payload.utm_medium   = attribution.utm_medium;
      if (attribution.utm_campaign) payload.utm_campaign = attribution.utm_campaign;
      if (attribution.utm_term)     payload.utm_term     = attribution.utm_term;
      if (attribution.utm_content)  payload.utm_content  = attribution.utm_content;
      if (attribution.landing_path) payload.landing_path = attribution.landing_path;
      if (attribution.referrer)     payload.referrer     = attribution.referrer;
    }
    const { data } = await api.post("/auth/signup", payload);
    localStorage.setItem("skillgap_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("skillgap_token");
    setUser(null);
  };

  const updateProfile = async (patch) => {
    const { data } = await api.put("/auth/me", patch);
    setUser(data.user);
    return data.user;
  };

  return (
    <AuthCtx.Provider value={{ user, loading, login, signup, logout, updateProfile, refresh: fetchMe }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
